import { UserResponseDto, SMARTBOOK_USER_TYPE } from '@headbox-ui/auth-hook/dist/useGlobalAuth'

export const userRoles: { [key: string]: string } = {
  B2C_GUEST: 'guest',
  BIZ_MEMBER: 'member',
  BIZ_MANAGER: 'manager',
  BIZ_ADMIN: 'administrator',
  HOST: 'host',
  ACCOUNT_MANAGER: 'account_manager',
  REGIONAL_MANAGER: 'regional_manager',
  ADMIN: 'admin'
}

export const userCountry: { [key: string]: string } = {
  AU: 'AU',
  GB: 'GB'
}

export enum ActorRoles {
  B2C_GUEST = 'B2C_GUEST',
  LEAD_FEED_HOST = 'LEAD_FEED_HOST',
  SMART_BOOK_HOST = 'SMART_BOOK_HOST',
  BIZ_MEMBER_LEGACY = 'BIZ_MEMBER_LEGACY',
  BIZ_MANAGER_LEGACY = 'BIZ_MANAGER_LEGACY',
  BIZ_ADMIN_LEGACY = 'BIZ_ADMIN_LEGACY',
  BIZ_MANAGER = 'BIZ_MANAGER',
  BIZ_MEMBER = 'BIZ_MEMBER',
  BIZ_ADMIN = 'BIZ_ADMIN',
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  REGIONAL_MANAGER = 'REGIONAL_MANAGER',
  ADMIN = 'ADMIN',
  UNKNOWN = 'UNKNOWN'
}

export const useActorRoleContext = (user: UserResponseDto): ActorRoles => {
  if (user?.roles.includes(userRoles.ADMIN)) {
    return ActorRoles.ADMIN
  }

  if (user?.roles.includes(userRoles.REGIONAL_MANAGER)) {
    return ActorRoles.REGIONAL_MANAGER
  }

  if (user?.roles.includes(userRoles.ACCOUNT_MANAGER)) {
    return ActorRoles.ACCOUNT_MANAGER
  }

  if (user?.roles.includes(userRoles.BIZ_ADMIN)) {
    if (user.country === userCountry.AU) {
      return ActorRoles.BIZ_ADMIN_LEGACY
    }

    return ActorRoles.BIZ_ADMIN
  }

  if (user?.roles.includes(userRoles.BIZ_MANAGER)) {
    if (user.country === userCountry.AU) {
      return ActorRoles.BIZ_MANAGER_LEGACY
    }

    return ActorRoles.BIZ_MANAGER
  }

  if (user?.roles.includes(userRoles.BIZ_MEMBER)) {
    if (user.country === userCountry.AU) {
      return ActorRoles.BIZ_MEMBER_LEGACY
    }

    return ActorRoles.BIZ_MEMBER
  }

  if (user?.roles.includes(userRoles.HOST)) {
    if (user.country === userCountry.GB && user.smartBook === SMARTBOOK_USER_TYPE.HOST) {
      return ActorRoles.SMART_BOOK_HOST
    }

    return ActorRoles.LEAD_FEED_HOST
  }

  if (user?.roles.includes(userRoles.B2C_GUEST)) {
    return ActorRoles.B2C_GUEST
  }

  return ActorRoles.UNKNOWN
}
